import u from "./ui.module.css";
import Button from "./Button";

export default function EmptyState({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
}) {
  return (
    <div className={u.empty}>
      {Icon ? <Icon className={u.emptyIcon} width={48} height={48} /> : null}
      {title ? <h3 className={u.emptyTitle}>{title}</h3> : null}
      {description ? <p className={u.emptyText}>{description}</p> : null}
      {actionLabel && onAction ? (
        <Button onClick={onAction}>{actionLabel}</Button>
      ) : null}
    </div>
  );
}
